import { useEffect, useRef, useSyncExternalStore } from 'react';
import { queueSnapshot, subscribeQueue } from '../vault/writeQueue';

/**
 * Calls [onRefused] when an edit of [path] is let go while this is mounted because a newer app
 * wrote the file: what the page shows for it is not in the vault, and it should show what is.
 */
export function useWhenRefused(path: string, onRefused: () => void): void {
  const { refused } = useSyncExternalStore(subscribeQueue, queueSnapshot, queueSnapshot);
  const latest = useRef(onRefused);
  latest.current = onRefused;
  const seen = useRef(refused);
  useEffect(() => {
    if (refused === seen.current) return;
    seen.current = refused;
    if (refused.includes(path)) latest.current();
  }, [refused, path]);
}
